import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NgForm} from '@angular/forms';
import {TranslateService} from "../translation/translate.service";
import {ICustomerProductReview} from "./product-review.models";
import {BsModalRef} from "ngx-bootstrap/modal";


@Component({
    selector: 'product-review-rating',
    templateUrl: './product-review-modal.component.html',
    styleUrls: ['./product-review-modal.component.scss'],
    standalone: false
})
export class ProductReviewModalComponent implements OnInit {

    @Output() readonly ratingSubmitted: EventEmitter<any> = new EventEmitter<any>();
    customerReview: ICustomerProductReview = new ICustomerProductReview();
    submitDisabled = true;
    submitted = false;
    reviewModified = false;
    ratingTranslation;
    rating: number;
    constructor(public bsModalRef: BsModalRef, private translateService: TranslateService,) {

    }

    ngOnInit() {
        this.rating = this.customerReview.rating;
        this.translateService.translate("cart.select.a.star.above").then((data: string) => {
            this.ratingTranslation = data;
        });
    }

    onChange(value: any){
        this.translateService.translate("cart.rating.description." + value).then((data: string) => {
            this.ratingTranslation = data;
        });
        this.submitDisabled = false;
        this.reviewModified = true;
    }

    onFormSubmit(form: NgForm) {
        this.customerReview.rating = this.rating;
        this.ratingSubmitted.emit(this.customerReview);
        this.submitted = true;

    }

}
